import { render, staticRenderFns } from "./appDownLoad.vue?vue&type=template&id=459856ef&scoped=true"
import script from "./appDownLoad.vue?vue&type=script&lang=js"
export * from "./appDownLoad.vue?vue&type=script&lang=js"
import style0 from "./appDownLoad.vue?vue&type=style&index=0&id=459856ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459856ef",
  null
  
)

export default component.exports